var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"looker",staticStyle:{"border":"0","display":"block","margin":"0 auto"},attrs:{"width":"90%","height":"auto","src":"https://lookerstudio.google.com/embed/reporting/f60cdb8a-6e4d-4f36-bc55-95c7333f4f24/page/SI2ED","frameborder":"1","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }